<template>
<navBack></navBack>
  <t-loading :loading="isLoading" text="加载中..." fullscreen />
  <div class="page">
    <t-input v-model="form.name" label="姓名" align="left" placeholder="请输入客户姓名"></t-input>
    <t-input v-model="form.mobile" type="number" label="手机" align="left" placeholder="请输入客户手机号"></t-input>

    <div class="spaceBar"></div>


    <t-cell title="性别" arrow hover @click="showSexItems = true" ext-class="weui-cells-title" :note="form.sex">

    </t-cell>

    <t-cell title="生日" @click="showDatePicker = true" arrow hover ext-class="weui-cells-title">

      <template #note> {{ form.birth ? form.birth : '请选择' }}</template>


    </t-cell>


    <template v-if="showMore">
      <div class="spaceBar"></div>

      <t-cell title="归属人" @click="showUserItems = true" arrow hover :note="form.consultant">


      </t-cell>

      <t-input v-model="form.recommender" label="推荐人" align="left" placeholder="请输入客户姓名"></t-input>
      <t-input v-model="form.note" label="备注" align="left" placeholder="请输入备注信息"></t-input>

      <t-cell>
        <template #leftIcon>
          <t-avatar shape="circle" :image="form.avatarUrl" />
        </template>
      </t-cell>


      <!-- <t-upload :default-files="[{ url: form.avatarUrl }]" multiple="false" :max="1" accept="image/*"
        :request-method="uploadFn" @remove="uploadDelect" @success="uploadSuccess" /> -->

    </template>
  </div>

  <div class="moreInfo">
    <t-button v-if="showMore" @click="toggleShowMore" size="small">
      收起
    </t-button>

    <t-button v-else @click="toggleShowMore" size="small">
      更多
    </t-button>
  </div>

  <div class="confirmBar">
    <t-button theme="primary" @click="doSubmit">提 交</t-button>
  </div>

  <t-action-sheet v-model="showSexItems" :items="['男', '女']" @selected="handleSexSelected"
    @cancel="showSexItems = false" />

  <t-action-sheet v-model="showUserItems" :items="userList" @selected="handleUserSelected"
    @cancel="showUserItems = false" />


  <t-popup v-model="showDatePicker" placement="bottom">
    <t-date-time-picker :value="form.birthday" :mode="['date']" title="选择生日" format="YYYY-MM-DD"
      @confirm="onDateConfirm" @cancel="showDatePicker = false" />
  </t-popup>


</template>

<script setup>
import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { stateShop,stateCustomer } from '@/store';
import { validatemobileNumber, getTimeBag } from '@/utils';
import navBack  from '@/components/nav-back.vue'
import dayjs from 'dayjs';
import { useRouter } from 'vue-router'
import { Toast } from 'tdesign-mobile-vue';
const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase
const showSexItems = ref(false);
const showDatePicker = ref(false);
const router = useRouter();
// 响应式数据
const showMore = ref(false)

const isLoading = ref(false);

const showUserItems = ref(false);
const userList = ref([])

// const tempFileURL = ref('');
const form = reactive({
  _id: '',
  name: "",
  mobile: "",
  sex: "男",
  deleted: 0,
  address: "",
  birth: "",
  zjm: "",
  point: 0,
  pointTotal: 0,
  status: 0,
  zengAmount: 0,
  storeAmount: 0,
  storeAmountTotal: 0,
  totalConsumAmount: 0,
  inviteStatus: 0,
  createAt: '',
  lastConsumAt: '',
  signs: [],
  level: '',
  note: '',
  type: '',
  openid: '',
  unionid: '',
  recommender: '',
  consultant: '无',
  sum: {
    order: 0,
    coupon: 0,
    discount: 0,
    cika: 0,
    follow: 0
  },
  shopId: '',
  tempImg: '',
  avatarUrl: 'cloud://cloud1-0gl88yx1944d9f7d.636c-cloud1-0gl88yx1944d9f7d-1324417878/meiye/boy.png'
})

// Vue Router


// 生命周期钩子
onMounted(() => {

  Object.assign(form, stateCustomer)
  loadShopUser();
})
 
const loadShopUser = () => {

  const db = app.database();
  const shopId = stateShop._id;
  db.collection('my_user').where({ shopId, deleted: 0, active: true }).field({ '_id': true, 'name': true }).get().then(res => {
    userList.value = res.data.map(item => item.name);
    console.log(userList.value, 234, res.data)
  })
}


// 方法定义
const handleSexSelected = (sex) => {

  form.sex = sex;
}

const onDateConfirm = (birth) => {

  form.birth = birth;
  showDatePicker.value = false;
}
const handleUserSelected = (user) => {
  form.consultant = user;
}

const toggleShowMore = () => {
  showMore.value = !showMore.value
}







const doSubmit = async () => {




  form.createAt = getTimeBag()
  let data = { ...form }
  delete data.sexArray
  delete data.avatarArray
  delete data.showMore

  if (!data.name) {

    Toast('请输入姓名')
    return
  }

  if (!data.mobile) {
    Toast('请输入手机号')
    return
  }

  if (!validatemobileNumber(data.mobile)) {
    Toast('手机号格式不正确')
    return
  }

  if (data.birth) {
    data.birth2 = dayjs(data.birth).format('MM-DD')
  }

  //手机是否重复

  const shopId = stateShop._id;
  const db = app.database();
  data.shopId = shopId;
  let mobileCount = await db.collection('my_customer').where({ deleted: 0, shopId, mobile: data.mobile }).count().then(res => {
    return res.total;
  })

  if (mobileCount > 0) {

    Toast('手机号重复了')
    return;
  }
    isLoading.value = true;

  let { id } = await db.collection('my_customer').add(data);
  Toast('添加成功');

  isLoading.value = false;
  stateCustomer._id = id;
  router.back();
}
</script>

<style scoped>
.page {
  padding: 3vw;
}

.editBar {
  display: flex;
  justify-content: space-between;
}

.spaceBar {
  margin-bottom: 5vw;
}

.page-section {
  padding: 5px 10px;
}

.avatar {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
}

.confirmBar {
  padding: 5vw;
  display: flex;
  justify-content: center;
}

.radioBox {
  width: 32vw;
  display: flex;
  justify-content: space-between;
}

.pickerInnerBar {
  width: 50vw;
  text-align: right;
}

.weui-cells-title {
  background-color: white;
}

.hiPicker {
  padding-left: 8vw;
}

.moreInfo {
  display: flex;
  justify-content: center;
}
</style>